<script setup lang="ts">
import { useAuthStore } from "~/stores/auth";

const account = useAccount();
const { isCommonNotificationsSlideoverOpen } = useDashboard();
const { fetchCompanySettingsBase, fetchCompanyLogo, companySettings, companyLogoUrl,  companyLogoLoading} = useCompanyData();
const n = useNotification()
const auth = useAuthStore()
const notifications = n.notifications
const nav = useNavigation();

onMounted(async () => {
  if (auth.status !== 'authenticated') return;

  const basePromise = fetchCompanySettingsBase();
  const logoPromise = fetchCompanyLogo();

  Promise.allSettled([basePromise, logoPromise]);
});

const hasNotifications = computed(() => {
  return notifications.value.filter(n => n.labelStatus === 'necitit').length > 0
})

const open = ref(false);

const groups = computed(() => [
  {
    id: "links",
    label: "Go to",
    items: nav.links.value.flat(),
  },
]);

const modalOpen = ref(true)

const handleApproveAll = () => {

}

</script>

<template>
  <TermsModalPrompt v-if="!(!!account.account.value?.gdpr && !!account.account.value?.terms_conditions)" v-model="modalOpen" @approve-all="handleApproveAll" />
  <UDashboardGroup unit="rem">
    <!-- left side bar -->
    <UDashboardSidebar id="default" v-model:open="open" class="w-[300px]" :ui="{
      root: 'p-4 border-r-0',
      header: 'py-2 h-fit w-full pl-0 sm:pl-0 bg-slate-50 lg:border-x lg:border-t border-slate-200 rounded-t-lg',
      body: 'bg-slate-50 lg:border-x lg:border-b border-slate-200 lg:rounded-b-lg',

    }" :defaultSize="300">

      <template #header>
        <USkeleton 
          v-if="companyLogoLoading"
          class="max-w-45 m-auto"
        />
        <img 
          v-else-if="companyLogoUrl"
          :src="companyLogoUrl"
          alt="Logo"
          class="max-w-45 m-auto" 
          />
        <h2 v-else>LOGO</h2>
      </template>
      <template #default>
        <div class="flex-col space-y-8 lg:mx-auto">
          <UNavigationMenu color="neutral" :items="nav.links.value[0]" orientation="vertical" />

          <div>
            <p class="text-base text-primary-500 font-medium">Suport</p>
            <UNavigationMenu color="primary" :items="nav.links.value[1]" orientation="vertical" variant="pill" :ui="{
              link: 'text-primary-600 hover:text-primary-800 hover:bg-slate-100',
              linkLeadingIcon: 'text-primary-600 hover:text-primary-800',
            }" />
          </div>

          <div>
            <p class="text-base text-primary-500 font-medium">Legal</p>
            <UNavigationMenu color="primary" :items="nav.links.value[2]" orientation="vertical" variant="pill" :ui="{
              link: 'text-primary-600 hover:text-primary-800 hover:bg-slate-100',
              linkLeadingIcon: 'text-primary-600 hover:text-primary-800',
            }" />
          <CAOCookies variant="link" icon="i-lucide-cookie" content-side="right" />
          </div>
        </div>

        <p class="mt-auto text-xs text-slate-500 font-medium text-center">
          © {{new Date().getFullYear() + " " + companySettings.footer }}
        </p>
      </template>

    </UDashboardSidebar>
    <UDashboardSearch :groups="groups" shortcut="meta_q" />

    <!-- top navbar -->
    <UDashboardPanel id="home" :ui="{ body: 'sm:p-0' }">
      <template #header>
        <UDashboardNavbar class="p-4 pr-6 border-b-0">
          <template #leading>
            <UDashboardSearchButton variant="outline" color="neutral" size="md" class="w-[300px]"
              :kbds="['meta', 'Q']" />
          </template>

          <template v-if="!nav.isStandalone" #right>
            <UTooltip text="Notifications" :shortcuts="['N']" :delayDuration="100">
              <UButton color="neutral" variant="outline" size="lg" square
                @click="isCommonNotificationsSlideoverOpen = true">
                <UChip color="error" inset :show="hasNotifications">
                  <UIcon name="i-lucide-bell" class="size-5 shrink-0" />
                </UChip>
              </UButton>
            </UTooltip>

            <UPopover>
              <UButton color="neutral" variant="outline" size="lg" square>
                <UIcon name="i-lucide-person-standing" class="size-5 shrink-0" />
              </UButton>

              <template #content>
                <AccessibilitySelector />
              </template>
            </UPopover>


            <CommonUserMenu />
          </template>
          <template #right>
            <UPopover>
              <UButton icon="i-lucide-person-standing" color="neutral" variant="outline" size="lg" square />

              <template #content>
                <AccessibilitySelector />
              </template>
            </UPopover>

            <UButton icon="i-lucide-log-out" class="rotate-180" color="neutral" variant="outline" size="lg" square :to="nav.nav.login().path" />
          </template>
        </UDashboardNavbar>
      </template>

      <template #body>
        <slot />
      </template>
    </UDashboardPanel>

    <CommonNotificationsSlideover />
  </UDashboardGroup>
</template>
